import React, { useState } from "react";
import { CopilotKit, useCopilotChat } from "@copilotkit/react-core";
import { useAgent } from "src/context/AgentContext";
import * as process from "process";
import { REACT_APP_API_BASE_URL } from "../../../../store/threads/threadsApi";
import { Button } from "../../../../components";

interface CopilotWrapperProps {
  children: React.ReactNode;
}

export const CopilotWrapper: React.FC<CopilotWrapperProps> = ({ children }) => {
  const { agent, threadId } = useAgent();

  return (
    <div>
      <CopilotKit
        agent={agent}
        threadId={threadId}
        runtimeUrl={
          REACT_APP_API_BASE_URL + '/copilotkit' || "http://localhost:3000/"
        }
      >
        {children}
      </CopilotKit>
    </div>
  );
};
